import type React from 'react';
import { theme } from '@shared/styles/theme';

export const getStyles = (): Record<string, React.CSSProperties> => ({
  container: {
    width: '100%',
  },
  title: {
    fontSize: theme.fontSize.xl,
    fontWeight: 'bold',
    color: theme.colors.text.primary,
    marginBottom: theme.spacing.xl,
    textAlign: 'center' as const,
  },
  errorMessage: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    backgroundColor: theme.colors.error,
    color: theme.colors.text.white,
    padding: theme.spacing.md,
    borderRadius: '4px',
    marginBottom: theme.spacing.lg,
    fontSize: theme.fontSize.sm,
  },
  formGroup: {
    marginBottom: theme.spacing.lg,
  },
  label: {
    display: 'block',
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.sm,
    fontWeight: '600',
    marginBottom: theme.spacing.sm,
  },
  input: {
    width: '100%',
    padding: theme.spacing.md,
    minHeight: '44px',
    border: `2px solid ${theme.colors.border.light}`,
    borderRadius: '6px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.md,
    boxSizing: 'border-box' as const,
  },
  passwordWrapper: {
    position: 'relative' as const,
    display: 'flex',
    alignItems: 'center',
  },
  passwordInput: {
    width: '100%',
    padding: theme.spacing.md,
    paddingRight: '48px',
    minHeight: '44px',
    border: `2px solid ${theme.colors.border.light}`,
    borderRadius: '6px',
    backgroundColor: theme.colors.background.secondary,
    color: theme.colors.text.primary,
    fontSize: theme.fontSize.md,
    boxSizing: 'border-box' as const,
  },
  eyeButton: {
    position: 'absolute' as const,
    right: '4px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    minWidth: '44px',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryButton: {
    width: '100%',
    padding: theme.spacing.lg,
    minHeight: '44px',
    backgroundColor: theme.colors.accent.emerald500,
    color: theme.colors.text.white,
    border: 'none',
    borderRadius: '14px',
    fontSize: theme.fontSize.md,
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    marginTop: theme.spacing.lg,
    borderBottom: '4px solid rgba(0, 0, 0, 0.2)',
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
    margin: `${theme.spacing.xl} 0`,
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    backgroundColor: theme.colors.border.light,
  },
  dividerText: {
    color: theme.colors.text.secondary,
    fontSize: theme.fontSize.sm,
    whiteSpace: 'nowrap' as const,
  },
  secondaryButton: {
    width: '100%',
    padding: theme.spacing.lg,
    minHeight: '44px',
    backgroundColor: theme.colors.accent.blue,
    color: theme.colors.text.white,
    border: 'none',
    borderRadius: '14px',
    fontSize: theme.fontSize.md,
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    borderBottom: '4px solid rgba(0, 0, 0, 0.2)',
  },
  fieldError: {
    fontSize: theme.fontSize.xs,
    color: theme.colors.error,
    marginTop: theme.spacing.xs,
    margin: `${theme.spacing.xs} 0 0 0`,
  },
});

export const styles = getStyles();
